export default {
    about: '/about',
    getExtra: '/property/GetExtra',
    getFilterProjectName: '/property/GetFilterProjectName',
    getFilterZone: '/property/GetFilterZone',
    getRoomType: '/property/GetRoomType',
    searchProp: '/property/SearchProp',
    getPropDetail: '/property/GetPropDetail',
    customerRegister: '/customer/register',
    userRegister: '/user/register',
    userLogin: '/user/login',
    userLogout: '/user/logout',
    userUpdate: '/user/update',
    userSearch: '/user/search',
    filterFacing: '/property/GetFacing',
    filterRoomAmenities: '/property/GetRoomAmenities',
    filterProjectFacilities: '/property/GetProjectFacilities',
    getPriceList: '/property/GetPriceList',
    getFloorList: '/property/GetFloorList',
    aboutUpdate: '/about/update',
    getCustomer: '/customer/get',
    provinces: '/master/provinces',
    districts: '/master/districts',
    subdistricts: '/master/subdistricts',
    forgot: '/user/forgot',
    userDelete: '/user/delete',
    addDownloadLog: '/property/AddDownloadLog',
    addShareLog: '/property/AddShareLog',
    addCopyLog: '/property/AddCopyLog',
    searchLog: '/property/SearchLog'
 }